import { css } from '@emotion/react'

// eslint-disable-next-line import/prefer-default-export
export const formMixin = () => css``

// This is an example of how the formMixin may be used to
// style a form layout using grid.

// export const formMixin = ({ theme }) => css`
//   &.vio-vio-seo_referral_program-lc {
//     @media (min-width: ${theme.breakpoints.sm}) {
//       display: grid;
//       grid-gap: 10px;
//       grid-template-areas:
//         'first_name last_name'
//         'referral_name zip_postal'
//         'email_address email_address'
//         'referral_email referral_email'
//         'submit_button submit_button'
//         'form_disclaimer form_disclaimer';
//     }
//   }

//   &.vio-vio-footer_request-lc {
//     @media (min-width: ${theme.breakpoints.sm}) {
//       display: grid;
//       grid-gap: 10px;
//       grid-template-areas:
//         'first_name last_name'
//         'phone_number zip_postal'
//         'email_address email_address'
//         'looking_to_secure looking_to_secure'
//         'submit_button submit_button'
//         'form_disclaimer form_disclaimer';

//       .options_looking_to_secure {
//         display: grid;
//         grid-gap: 10px;
//         grid-template-areas: 'home business apartment';
//       }
//     }
//   }

//   &.vio-vio-megaform_request_quote-lc {
//     @media (min-width: ${theme.breakpoints.sm}) {
//       display: grid;
//       grid-gap: 10px;
//       &.step-1 {
//         grid-template-areas: 'radioButtons radioButtons';
//       }

//       &.step-2 {
//         grid-template-areas: 'radioButtons2 radioButtons2';
//       }

//       &.step-3 {
//         grid-template-areas: 'radioButtons3 radioButtons3';
//       }

//       &.step-4 {
//         grid-template-areas: 'radioButtons4 radioButtons4';
//       }

//       &.step-5 {
//         grid-template-areas:
//           'first_name last_name'
//           'zip_postal phone_number'
//           'email_address email_address'
//           'submit_button submit_button'
//           'form_disclaimer form_disclaimer';
//       }
//     }
//   }
// `
